var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2045_7227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66663 8.66795C6.95293 9.0507 7.3182 9.3674 7.73766 9.59657C8.15712 9.82574 8.62096 9.96202 9.09773 9.99617C9.57449 10.0303 10.053 9.96152 10.5009 9.79447C10.9487 9.62741 11.3554 9.36599 11.6933 9.02795L13.6933 7.02795C14.3005 6.39927 14.6365 5.55726 14.6289 4.68327C14.6213 3.80929 14.2707 2.97324 13.6527 2.35522C13.0347 1.73719 12.1986 1.38663 11.3246 1.37903C10.4506 1.37144 9.60863 1.70742 8.97996 2.31461L7.83329 3.45461",
    stroke: "#475569",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33334 7.33283C9.04704 6.95008 8.68177 6.63338 8.26231 6.40421C7.84285 6.17503 7.37901 6.03875 6.90224 6.00461C6.42548 5.97047 5.94695 6.03925 5.49911 6.20631C5.05127 6.37337 4.6446 6.63479 4.30668 6.97283L2.30668 8.97283C1.69948 9.60151 1.3635 10.4435 1.3711 11.3175C1.37869 12.1915 1.72926 13.0275 2.34728 13.6456C2.96531 14.2636 3.80135 14.6142 4.67534 14.6217C5.54933 14.6293 6.39134 14.2934 7.02001 13.6862L8.16001 12.5462",
    stroke: "#475569",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2045_7227"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.6c8b6d7a5fbf87ce10ff1278f829c1ba.svg";
export { ForwardRef as ReactComponent };